import * as Dialog from '@radix-ui/react-dialog';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import { IconButton } from '~/chords/IconButton';
import { cn } from '~/chords/lib/cn';

import type { SlideOutHeaderProps } from '../types';

export const SlideOutHeader = forwardRef<HTMLDivElement, SlideOutHeaderProps>(
  ({ children, showCloseButton = true, asChild, ...props }, ref) => {
    const { t } = useTranslation('common');

    return (
      <div
        ref={ref}
        {...props}
        className={cn({ 'flex justify-between p-lg pb-md': !asChild })}
      >
        <Dialog.Title
          asChild={asChild}
          className={cn({ 'text-headline-md font-bold': !asChild })}
        >
          {children}
        </Dialog.Title>
        {!asChild && showCloseButton ? (
          <div className="-mr-sm -mt-sm">
            <Dialog.Close asChild>
              <IconButton
                type="button"
                iconType="xmark"
                iconVariant="regular"
                size="large"
                aria-label={t('closePanel')}
              />
            </Dialog.Close>
          </div>
        ) : null}
      </div>
    );
  },
);

SlideOutHeader.displayName = 'SlideOut.Header';
